module.exports = __webpack_public_path__ + "static/img/maro-qr.699ec65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maro-qr.png
// module id = fw2K
// module chunks = 0